<template>
  <div>
      <!--Header Components-->
      <base-header class="mt-4 pb-6" type=""/>
      <b-container fluid class="mt--6">
        <div>
          <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['SALES_RECEIPTS']}}</h3>
                    </b-col>
                    <b-col cols="4">
                       <base-button type="success" @click="newSaleDocument" class="float-right">
                          <i class="fa fa-plus"></i>
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="4" >
                    <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch">
                    </base-input>
                  </b-col>
                  <b-col md="2" >
                    <base-input :label="language_terms['DATE_FROM']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_from">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :label="language_terms['DATE_TO']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_to">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input :label="language_terms['DOCUMENT_TYPE']">
                      <el-select v-model="filter.doc_type" filterable>
                          <el-option v-for="doctype in doc_type_options"
                                    :key="doctype.value"
                                    :label="doctype.label"
                                    :value="doctype.value">
                          </el-option>
                        </el-select>
                    </base-input>
                  </b-col>
                  <b-col cols="1" class="mt-4">
                    <base-button type="primary" @click="clickOnSearch" class="mt-2">
                      <i class="fa fa-search"></i>
                    </base-button>
                  </b-col>
                </b-row>
              </card>
              <!-- Search Results -->
              <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>
            </div>
          </b-col>
        </b-row>
        <!-- <a href="javascript:void(0)" class="float" @click="newSaleDocument">
          <i class="fa fa-plus my-float"></i>
        </a> -->
      </b-container>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  props:
  {
        type: {
          type: String,
          default: 'SALES',
          description: 'Type',
          required:true
        },
        addNew: {
          type: String,
          default: 'Add New Sale Document',
          description: 'Add New Sale Document',
          required:true
        },
  },
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
      computed:{
      ...mapState({
        receipt_filter:state => state.receipts.filter,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        receipts: state => state.receipts.sales_receipts

      }),
    },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
      receipts: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        console.log("A")
        this.items = this.receipts
      }
    }
  },
  async mounted()
  {
      // console.log(this.type)
      if(this.type == 'SALES')
      {
          this.items = this.receipts
      }

      this.updateTableLang()

      // if(this.receipt_filter)
      // {
      //   this.filter = this.receipt_filter
      // }
  },
  data(){
    return{
      doc_type_options:[
        {
          label:"RECEIPTS",
          value:'RECEIPTS'
        },
        {
          label:"CREDIT NOTE",
          value:"CN"
        },
        {
          label:"OFFSET",
          value:"OFFSET"
        },
        {
          label:"CONTRA",
          value:"CONTRA"
        },
        {
          label:"BAD DEBTS",
          value:"BAD DEBTS"
        },
      ],
      fullPage:true,
      loadingCounter: 0,
      filter:{
        keyword:"",
        date_from:null,
        date_to:null,
        type:null,
        doc_type:'RECEIPTS',
        status:'ALL'
      },
      items:[],
      tableColumns: [
            {
              prop: 'code',
              label: 'Document#',
              minWidth: 135,
              sortable: true,
              key:'CODE'

            },
            {
              prop: 'contact_name',
              label: 'Customer',
              minWidth: 180,
              sortable: true,
              key:'CUSTOMER'

            },
            {
              prop: 'date',
              label: 'Date',
              minWidth: 120,
              sortable: true,
              key:'DATE'

            },
            {
              prop: 'mode',
              label: 'Payment Mode',
              minWidth: 130,
              sortable: true,
              key:'PAYMENT_MODE'

            },
            {
              prop: 'reference',
              label: 'Reference',
              minWidth: 130,
              sortable: true,
              key:'REFERENCE'
            },
            {
              prop: 'amount',
              label: 'Amount',
              minWidth: 130,
              sortable: true,
              key:'AMOUNT'
            },
            // {
            //   prop: 'is_void',
            //   label: 'Void',
            //   minWidth: 140,
            //   sortable: true,
            //   key:'IS_VOID'

            // },
        ],

    }
  },

  methods:{
     updateTableLang(){
      for(let i=0; i < this.tableColumns.length;i++)
      {
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    },
    async clickOnSearch(){
      this.filter.type = this.type
      this.loadingCounter++
      await this.$store.dispatch("receipts/quickSearch", this.filter);
      this.loadingCounter--
    },
    clickOnReset(){
      this.filter = {
          keyword:"",
          date_from:null,
          date_to:null,
          type:'SALES',
          doc_type:'RECEIPTS',
          status:'ALL'
      }
    },
    async newSaleDocument(){
       this.$router.push(this.$props.addNew+"_new")
    }
  }
}
</script>
